<template>
  <table-layout>
    <template v-slot:button>
      <v-btn class="button" outlined @click="openVideoEditPopup([])">
        동영상 업로드
      </v-btn>
    </template>
    <template v-slot:table>
      <v-data-table
        :headers="headers"
        :loading="loading"
        :items="data"
        no-data-text="조회된 데이터가 없습니다"
        mobile-breakpoint="md"
      >
        <template v-slot:item.createDate="{ value }">
          <div>{{ setTableDateFormat(value) }}</div>
        </template>
        <template v-slot:item.viewStatus="{ item }">
          <v-btn class="button" outlined @click="openViewStatusPopup(item)">시청현황</v-btn>
        </template>
        <template v-slot:item.useYn="{ value }">
          <div>{{ dataConversion(useYnList, value) }}</div>
        </template>
        <template v-slot:item.setting="{ item }">
          <v-btn class="button" outlined @click="openVideoEditPopup(item)">동영상 설정</v-btn>
        </template>
      </v-data-table>
    </template>
    <template v-slot:popup>
      <DashboardPopup
        :is-show="isShowStatus"
        :video-info="selectVideoInfo"
        @close="isShowStatus = false"
      />
      <ManagePopup
        :is-show="isShowManage"
        :categoryList="categoryList"
        :videoDataProps="editItem"
        :useYnList="useYnList"
        :type="popupType"
        @refresh="$emit('refresh')"
        @close="isShowManage = false"
      />
    </template>
  </table-layout>
</template>
<script>
import TableMixin from "@/mixin/TableMixin"
import ManagePopup from "@/pages/Lecture/popup/ManagePopup.vue";
import _ from "lodash";
import TableLayout from "@/common/layout/TableLayout.vue";
import DashboardPopup from "@/pages/Lecture/popup/DashboardPopup.vue";
import DateMixin from "@/mixin/DateMixin";

export default {
  name: "LectureManageTable",
  components: {DashboardPopup, TableLayout, ManagePopup},
  props: ["categoryList", "data"],
  mixins: [TableMixin, DateMixin],
  data() {
    return {
      loading: false,
      headers: [
        { text: "동영상 제목", value: "title", width: "30%", align: "left", sortable: false },
        { text: "카테고리명", value: "categoryNm", width: "13%", align: "center", sortable: false },
        { text: "담당자명", value: "createNm", width: "7%", align: "center", sortable: false },
        { text: "업로드 날짜", value: "createDate", width: "7%", align: "center", sortable: false },
        { text: "영상 시간", value: "playTime", width: "7%", align: "center", sortable: false },
        { text: "조회수", value: "viewMemberCnt", width: "7%", align: "center", sortable: false },
        { text: "노출여부", value: "useYn", width: "7%", align: "center", sortable: false },
        { text: "시청현황", value: "viewStatus", width: "10%", align: "center", sortable: false },
        { text: "설정", value: "setting", width: "12%", align: "center", sortable: false },
      ],
      isShowStatus: false,
      isShowManage: false,
      selectVideoInfo: {},
      editItem: {},
      popupType: '',
      useYnList: [
        { text: "노출", value: "Y" },
        { text: "미노출", value: "N" }
      ]
    }
  },
  methods: {
    openViewStatusPopup(item) {
      this.selectVideoInfo = item;
      this.isShowStatus = true;
    },
    openVideoEditPopup(item) {
      const type = _.isEmpty(item) ? 'new' : 'edit';

      this.editItem = item;
      this.popupType = type;
      this.isShowManage = true;
    }

  }
};
</script>